import type { IconType } from '#ui/components/Icon';
import type { NotificationType } from '#ui/constants';

export const notificationIconTypes: Record<
  NotificationType,
  IconType | undefined
> = {
  default: undefined,
  success: 'check-circle',
  info: 'info',
  warning: 'alert-triangle',
  danger: 'alert-diamond',
};

export const notificationIconColorClasses: Record<NotificationType, string> = {
  default: '',
  info: 'text-blue-100',
  success: 'text-green-100',
  warning: 'text-orange-100',
  danger: 'text-red-100',
};

export const notificationLinkColorClasses: Record<NotificationType, string> = {
  default: '',
  info: '',
  success: 'text-neutral-200!',
  warning: 'text-neutral-200!',
  danger: 'text-neutral-200!',
};
